// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ab355eea","389":"8cc2bf2d","455":"e1fc31e8","977":"be06c779"}[chunkId] + ".chunk.js";
};